import { render, staticRenderFns } from "./BusApplicantinfo.vue?vue&type=template&id=60e799f3&"
import script from "./BusApplicantinfo.vue?vue&type=script&lang=js&"
export * from "./BusApplicantinfo.vue?vue&type=script&lang=js&"
import style0 from "./BusApplicantinfo.vue?vue&type=style&index=0&id=60e799f3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports